module.exports = __webpack_public_path__ + "img/赵村镇.32004be0.png";